import React from "react";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import CreateCampaign from "./CreateCampaign";
import "../../../components/common/css/index.scss";

const CreateCampaignPage = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <CreateCampaign />
      </div>
    </div>
  );
};

export default CreateCampaignPage;
